<nav class="h-full w-2xs bg-gray-200 rounded-br-2xl fixed">
  <div
    class="flex flex-col w-95/100 h-full justify-between p-4 bg-linear-to-b from-primary to-teal-500 rounded-br-3xl"
  >
    <div class="flex flex-col gap-2">
      <img
        priority
        ngSrc="/brand/abc-groep-logo_full-white.svg"
        alt="ABC-Groep logo"
        width="300"
        height="110"
        class="w-9/10 h-auto mx-auto mb-4"
      />
      <app-navbar-button route="/coaching" label="Coaching" [icon]="icons.messageCircle" />
      <app-navbar-button route="/goals" label="Doelen" [icon]="icons.goal" />
      <app-navbar-button
        route="/learning-hub"
        label="Leerbibliotheek"
        [icon]="icons.graduationCap"
      />
      <app-navbar-button
        route="/dashboard"
        label="Statistieken"
        [icon]="icons.chartPie"
        [roles]="[UserRole.MANAGEMENT]"
      />
    </div>
    <div class="flex gap-2 flex-col">
      <app-navbar-button route="/" label="Profiel" [icon]="icons.circleUser" [exact]="true" />
      <app-navbar-button label="Uitloggen" [icon]="icons.logOut" (action)="logout()" />
    </div>
  </div>
</nav>
